import React, { useState } from 'react';
import Panel from 'Components/Panel/Panel';
import Supplier from './SuppliersOperations/Supplier';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import Operations from './Operations/Operations';
import OperationFilters from './filters/operation/OperationFilters';
import SupplierFilters from './filters/supplier/SupplierFilters';

const SuppliersOperations = () => {

    const [supplierIdSelected, setSupplierIdSelected] = useState([])
    const [operationIdSelected, setOperationIdSelected] = useState([])

    const [suppliersListFilter, setSuppliersListFilter] = useState(null)
    const [operationsListFilter, setOperationsListFilter] = useState(null)
    const [classificationIdSelected, setClassificationIdSelected] = useState(null)

    const [reloadListSupplier, setReloadListSupplier] = useState(false)
    const [reloadListOperation, setReloadListOperation] = useState([])

    const mainStyle = {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '100%',
        maxHeight: '100%',
        width: '100%'
    };

    const leftStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    const rightStyle = {
        display: 'flex',
        flexDirection: 'column',

    };

    return (
        <LayoutDefault>
            <Panel style={mainStyle}>
                <Panel style={leftStyle} className={'main-modal two left'}>
                    <SupplierFilters
                        onUpdateSupplierIdSelected={setSupplierIdSelected}
                        onUpdateSuppliers={setSuppliersListFilter}
                        onUpdateReloadListSupplier={setReloadListSupplier}
                        supplierIdSelected={supplierIdSelected}
                        reloadListSupplier={reloadListSupplier}
                    />
                    <Supplier
                        onUpdateSupplierIdSelected={setSupplierIdSelected}
                        onUpdateSuppliers={setSuppliersListFilter}
                        onUpdateReloadListSupplier={setReloadListSupplier}
                        supplierIdSelected={supplierIdSelected}
                        supplierListFilter={suppliersListFilter}
                    />
                </Panel>
                <Panel style={rightStyle} className={'main-modal two right'}>
                    <OperationFilters
                        onUpdateReloadListOperation={setReloadListOperation}
                        onUpdateOperations={val => { setOperationsListFilter(val) }}
                        onUpdateClassificationIdSelected={val => { setClassificationIdSelected(val) }}
                        onUpdateOperationIdSelected={setOperationIdSelected}
                        operationIdSelected={operationIdSelected}
                        classificationIdSelected={classificationIdSelected}
                        supplierIdSelected={supplierIdSelected}
                        reloadListOperation={reloadListOperation}
                    />
                    <Operations
                        onUpdateOperationIdSelected={setOperationIdSelected}
                        onUpdateReloadListOperation={setReloadListOperation}
                        operationIdSelected={operationIdSelected}
                        supplierIdSelected={supplierIdSelected}
                        operationsListFilter={operationsListFilter}
                    />
                </Panel>
            </Panel>
        </LayoutDefault>
    );
};

export default SuppliersOperations;
